function SwitchOurClients(container){

	container.find("img.grey").hover(
		function() {
			$(this).stop().animate({"opacity": "0"}, "slow");
		},
		function() {
			$(this).stop().animate({"opacity": "1"}, "slow");
		});

	$(container).click(function(){
		var href = container.attr('href');

		if ( !container.parent('li').hasClass('active') ){
			$('.clients-image-exp').hide();
			$('.j-switch-our-clients').parent('li').removeClass('active');

			container.parent('li').addClass('active');
			$(href).show();
			return false;
		}
		return false;
	});

}

if (typeof define === "function" && define.amd) {
	define('Controls/SwitchOurClients',[], function() {
		return SwitchOurClients;
	});
};
